// The 2x2 art grid in the navy hero, ported from apps/frontend.
//
// Decorative: the heading beside it carries the meaning, so the tiles are
// alt="" and aria-hidden rather than described. Desktop only, because on a
// phone four tiles would push the newsletter CTA below the fold.
//
// The images are served from assets.gazar.dev. This app's CSP allows https:
// image sources, so no server change was needed to show them here.
//
// loading="lazy" is load-bearing and is not a micro-optimisation, changed
// 29 Aug 2026. It does two things that "eager" got wrong on this surface:
//
//   1. React 19 hoists a <link rel="preload" as="image"> into <head> for every
//      eagerly-loaded <img> it renders on the server. A preload ignores CSS
//      entirely, so all four tiles were fetched at high priority on first paint
//      even though this grid is `hidden lg:grid`. Phones paid for four images
//      they can never see, and this audience is largely on Iranian mobile
//      connections.
//   2. A lazy image inside a display:none subtree is not fetched at all until
//      it becomes visible, so mobile now pays nothing. On desktop the grid is
//      already in the viewport at load, so lazy still fetches it immediately
//      and nothing above the fold gets slower.
export default function HeroArtGrid({ images }: { images: string[] }) {
  const tiles = images.filter(Boolean).slice(0, 4);
  if (!tiles.length) return null;
  return (
    <div className="hidden lg:grid grid-cols-2 gap-4" aria-hidden="true">
      {tiles.map((src, i) => (
        <img
          key={src || i}
          src={src}
          alt=""
          className="w-full aspect-[4/3] object-cover rounded-xl ring-1 ring-white/15 shadow-2xl"
          loading="lazy"
          decoding="async"
        />
      ))}
    </div>
  );
}
